export const MAX_HOURS_PER_WEEK = 168;
export const MAX_SPEND_EUR = 100000;

export const TIME_LIMIT_VALUES = [25, 50, 75, 100];

export const SPEND_LIMIT_VALUES = [500, 1000, 2000, 10000];
